/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getSegments.defs.js";
export { main as default } from "./getSegments.defs.js";
